import { FormControlLabel, Grid, Radio } from '@material-ui/core';
import React from 'react';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import TextInput from '../../../../lib/TextField';
import ToggleTabs, { OFF, ON } from '../../../../lib/ToggleTabs';
import { ProfileEvent, useProfileInfo } from './profile-context';
import { ObjectiveDetail, SubjectiveDetail } from './utils';

const RenderCheckBoxFields = () => {
    const { state: profileState, dispatch } = useProfileInfo();
    const {
        objective: { type: objectiveType },
        subjective,
        errors: { subjective: subjectiveErrors },
    } = profileState;
    const handleChange = (key: keyof typeof SubjectiveDetail, checked: boolean) => {
        const numSelected = subjective.length;
        if (checked) {
            if (numSelected === (objectiveType === ObjectiveDetail.None ? 3 : 1)) {
                // remove the last selected type and insert
                dispatch({
                    action: ProfileEvent.SetSubjectiveDetails,
                    payload: [
                        ...subjective.slice(0, numSelected - 1),
                        { type: key as SubjectiveDetail, value: '' },
                    ],
                });
            } else {
                // push a new type to the array
                dispatch({
                    action: ProfileEvent.SetSubjectiveDetails,
                    payload: [...subjective, { type: key as SubjectiveDetail, value: '' }],
                });
            }
        } else {
            // remove the current type from the array
            const currentTypeIndex = subjective.findIndex((o) => o.type === key);
            if (currentTypeIndex !== -1) {
                dispatch({
                    action: ProfileEvent.SetSubjectiveDetails,
                    payload: [
                        ...subjective.slice(0, currentTypeIndex),
                        ...subjective.slice(currentTypeIndex + 1),
                    ],
                });
            }
        }
    };
    const subjectiveTypes = subjective.map((o) => o.type);
    return (
        <>
            {(Object.values(SubjectiveDetail) as Array<keyof typeof SubjectiveDetail>).map(
                (key, index) => {
                    return (
                        <CheckBoxField
                            onChange={(e) => handleChange(key, e.target.checked)}
                            label={key}
                            value={subjectiveTypes.includes(key as SubjectiveDetail)}
                        />
                    );
                },
            )}
        </>
    );
};

export const SubjectiveDetails = (props: {}) => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    const { objective, subjective } = profileState;
    return (
        <>
            <p className="details-heading">
                {objective.type === ObjectiveDetail.None
                    ? 'Please select any three of the below parameters'
                    : 'Please select any one of the below parameters'}
            </p>
            <div className="render-fields">
                <RenderCheckBoxFields />
            </div>
            <Grid container spacing={2} className="grid-gap">
                {subjective.map((field, index) => (
                    <Grid item xs={8} md={4}>
                        <TextInput
                            value={field.value}
                            variant="filled"
                            className="filled-input-inactive"
                            onChange={(e) => {
                                // change the value for the type at the current index
                                profileDispatch({
                                    action: ProfileEvent.SetSubjectiveDetails,
                                    payload: [
                                        ...subjective.slice(0, index),
                                        { type: subjective[index]['type'], value: e.target.value },
                                        ...subjective.slice(index + 1),
                                    ],
                                });
                            }}
                            label={field.type && `Please enter ${field.type}`}
                            error={
                                !!profileState.errors.subjective[index].value &&
                                profileState.submitted
                            }
                            helperText={
                                profileState.submitted && profileState.errors.subjective[index].value
                            }
                            fullWidth
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};
